import type { Assignment, ProjectSummary } from "@/hooks/useProjectBoardData";
import { addWeeks, parseISODate, toISODateString } from "@/utils/dateUtils";
import { getStartOfWeek } from "@/utils/weekUtils";

export interface ProjectAvailabilityFocusData {
  project: ProjectSummary;
  assignment: Assignment;
}

export function requiredHoursByWeekForFocus(focus: ProjectAvailabilityFocusData): Map<string, number> {
  const requiredHoursByWeek = new Map<string, number>();
  const projectStartDate = focus.project.start_date;
  const projectNumWeeks = focus.project.num_weeks;

  if (!projectStartDate || projectNumWeeks == null || projectNumWeeks < 1) {
    return requiredHoursByWeek;
  }

  const weeklyHours = focus.assignment.weekly_hours_allocated ?? [];
  const projectStart = getStartOfWeek(parseISODate(projectStartDate));

  for (let weekIndex = 0; weekIndex < projectNumWeeks; weekIndex += 1) {
    const weekStart = toISODateString(addWeeks(projectStart, weekIndex));
    requiredHoursByWeek.set(weekStart, Math.max(0, weeklyHours[weekIndex] ?? 0));
  }

  return requiredHoursByWeek;
}
